import { orderServiceInstance } from "@stadium/services/axios";
import { camelizer } from "@stadium/helpers/formatter";
import { downloadBlobAsCSV, getAttachmentNameFromHeaders } from "@stadium/helpers";

const { get, post } = orderServiceInstance;

export const fetchGiftCodeDetails = async (number) =>
  get(`/gift_codes/${number}`).then((res) => camelizer(res));

export const fetchGiftCodeDetailsByCode = async (giftCode) =>
  post("/gift_codes/detail", { code: giftCode }).then((res) => camelizer(res));

export const redeemGiftCode = async (giftCode) =>
  post("/gift_codes/redeem", { code: giftCode }).then((res) => camelizer(res));

export const downloadGiftCodes = async (token) =>
  get(`/gift_codes/download_codes?token=${token}`, {}, { bypassSerialisation: true }).then(
    (res) => {
      const fallbackName = `gift-codes-${new Date().toISOString().slice(0, 10)}.csv`;
      const contentDisposition = res?.headers?.["content-disposition"];
      const fileName = getAttachmentNameFromHeaders(contentDisposition, fallbackName);

      downloadBlobAsCSV({
        blob: res.data,
        fileName: fileName || fallbackName,
      });
    },
  );
